<template lang="html">

	<div class="beneficios">

		<section class="banner-intro white animation full-view-intro -middle column-center" :data="id" :style="`background:url(/static/img/productos/${id}/background-intro-beneficios.jpg) center bottom/cover`">

			<h1 class="title -intro" v-html="$t(`productos.${id}.nombre`)"></h1>

			<h2 class="subtitle-intro">{{$t('vistas.beneficios')}}</h2>

		</section>

		<section class="cuerpo-beneficios container -xxs animation">

			<h3 class="title -black -xs" v-html="$t(`productos.${id}.beneficios.titulo`)"></h3>

			<div class="beneficios-list" v-if="id != ''">

				<article v-for="(el,key) in $t(`productos.${id}.beneficios.list`)" :class="['beneficio-el animation-el', (key > 5) ? '' : '']">
					<span class="numero" v-if="lang != 'ja'">{{key+1}}</span>

					<h3 class="titulo">{{el.titulo}}</h3>

					<p class="cuerpo">{{el.cuerpo}}</p>

				</article>
				
			</div>

			<router-link class="btn -black" :to="$t(`enlaces.${id}`)+'#beneficios'">
				<span>{{$t('volver_a')}} {{$t(`productos.${id}.nombre`)}}</span>
			</router-link>

		</section>

	</div>

</template>

<script lang="js">
	import {mapGetters} from 'vuex';
	require('waypoints/lib/noframework.waypoints.js')
	export default  {
		name: 'beneficios',
		data(){
			return {
				id : '',
			}
		},
		mounted(){
			setTimeout(e => {
				this.waypoints();
			},100)
			this.setID();
		},
		methods : {
			waypoints : function() {
				var waypoints = document.getElementsByClassName('animation-el');
				for (var i = 0; i < waypoints.length; i++) {
					new Waypoint({
						element: waypoints[i],
						offset : '80%',
						handler: function() {
							this.element.classList.add("launched")  
						}
					});
				}
			},
			setID : function(){
				let params = {
					"vino" : "vino",
					"cava" : "cava",
					"aceite" : "aceite",
					"azafran" : "azafran",
					"wine" : "vino",
					"sparkling-wine" : "cava",
					"olive-oil" : "aceite",
					"saffron" : "azafran",
					"queso" : "queso",
					"cheese" : "queso"
				}

				this.id = params[this.$route.params.id];
			}
		},
		 computed :{
		...mapGetters({
			lang : 'getLanguage'
		})
		}
	}
</script>

<style scoped lang="scss">

	@import "@/assets/css/colors.scss";

	.cuerpo-beneficios{
		padding-top:75px;
		padding-bottom: 50px;
		overflow: hidden;

		.title{
			text-align: center;
			padding-bottom: 20px;
			margin-bottom: 20px;
			opacity: 0;
			transition: 1s;
			transition-delay: 1.3s;
			transform: translateY(-200px);

			&::before{
				display:inline-block;
				left: 50%;
				margin-left: -25px;
			}
		}

		.beneficios-list{
			margin-top: 40px;
		}

		.beneficio-el{
			width: 100%;
			display: inline-block;
			padding-bottom: 40px;
			color: black;
			padding-left: 50px;
			position: relative;
			overflow: hidden;

			.numero{
				position: absolute;
				left: 0;
				top: 0;
				width: 30px;
				height: 30px;
				line-height: 30px;
				border: 1px solid $plum;
				color: $plum;
				font-weight: 800;
				font-size: 20px;
				border-radius: 50%;
				font-family: 'Yeseva One', cursive;
				transform: translateX(-150px);
				opacity: 0;
				transition: 1s;
			}

			.titulo{
				width: 100%;
				font-size: 20px;
				line-height: 30px;
				font-weight: 600;
				color:$black-two;
				display: inline-block;
				text-align: left;
				transform: translateY(-150px);
				opacity: 0;
				transition: 1s;
				transition-delay: .3s;
			}

			p{
				text-align: justify;
				font-weight: 400;
				transform: translateY(150px);
				opacity: 0;
				transition: 1s;
				transition-delay: .5s;
			}

			&.launched{
				.numero, .titulo, p{
					transform: translate(0);
					opacity: 1;
				}
			}
		}


		&.launched{
			.title{
				transform: translateY(0);
				opacity: 1;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/views/productos/beneficios.vue